import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent {
  @Input() bold = true;
  @Input() title: string;
  @Input() tiny: boolean; // 12px
  @Input() medium: boolean; // 14px
  @Input() normal: boolean; // 18px
  @Input() big: boolean; // px
  @Input() capitalized: boolean;
}
